import { Link, useNavigate } from "react-router";
import {
    Button,
    Card,
    CardBody,
    CardLink,
    CardText,
    CardTitle,
    Col,
    Container,
    Row,
} from "reactstrap";
import useAuth from "../hooks/useAuth";

export default function Home() {
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();

    if (auth.viewLevel === "myreports") {
        navigate('/myreports');
    }
    if (auth.viewLevel === "adminreports" && auth.role !== "SuperAdmin" && auth.role !== "PowerUser") {
        navigate('/unauthorized');
    }

    const isKy = auth.isKy;
    const isCa = auth.isCa;
    const isWa = auth.isWa;
    const hasAnyCAProgram = auth.hasAnyCAProgram;
    const hasCalJacProgram = auth.hasCalJacProgram;
    const hasIsaProgram = auth.hasIsaProgram;

    return (
        <Container>
            <Card>
                <CardBody>
                    <Row>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">ISO Summary Report</CardTitle>
                                    <CardText>
                                        Report for generating summarized training completions based
                                        on ISO Codes.
                                    </CardText>
                                    <Link
                                        to="/isosummary/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">ISO Detail Report</CardTitle>
                                    <CardText>
                                        Report for generating detailed training completions based on
                                        ISO Codes.
                                    </CardText>
                                    <Link
                                        to="/isodetail/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">Detailed Completions Report</CardTitle>
                                    <CardText>
                                        Completion data and training hours per learner (active
                                        enrollments)
                                    </CardText>
                                    <Link
                                        to="/detailedcompletions/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">Training Plan Report</CardTitle>
                                    <CardText>Report for generating Training Plans.</CardText>
                                    <Link
                                        to="/learningplan/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">Observation Checklist Report</CardTitle>
                                    <CardText>
                                        Report for generating approved Observation Checklists.
                                    </CardText>
                                    <Link
                                        to="/checklist/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4 flex-fill">
                            {isKy ? (
                                <Card className="border-0">
                                    <CardBody className="text-center">
                                        <CardTitle tag="h5">
                                            Kentucky Training Detail Report
                                        </CardTitle>
                                        <CardText>
                                            Report for generating detailed training completions based
                                            on Kentucky codes
                                        </CardText>
                                        <Link
                                            to="/kentuckydetail/form"
                                            className="btn btn-primary mx-auto"
                                        >
                                            View
                                        </Link>
                                    </CardBody>
                                </Card>
                            ) : null}
                            {isCa ? (
                                <>
                                    <Card className="border-0">
                                        <CardBody className="text-center">
                                            <CardTitle tag="h5">CAL-JAC Report</CardTitle>
                                            <CardText>
                                                Report for generating training completions for California
                                                Joint Apprenticeship Committee
                                            </CardText>
                                            <Link
                                                to="/californiajac/form"
                                                className="btn btn-primary mx-auto"
                                            >
                                                View
                                            </Link>
                                        </CardBody>
                                    </Card>
                                </>
                            ) : null}
                            {isCa && hasIsaProgram ? (
                                <>
                                    <Card className="border-0">
                                        <CardBody className="text-center">
                                            <CardTitle tag="h5">ISA Audit Report</CardTitle>
                                            <CardText>
                                                Report for generating training completions for
                                                an ISA Reimbursement program
                                            </CardText>
                                            <Link
                                                to="/isaaudit/form"
                                                className="btn btn-primary mx-auto"
                                            >
                                                View
                                            </Link>
                                        </CardBody>
                                    </Card>
                                </>
                            ) : null}
                            {isWa ? (
                                <>
                                    <Card className="border-0">
                                        <CardBody className="text-center">
                                            <CardTitle tag="h5">WSRB Summary Report</CardTitle>
                                            <CardText>
                                                Report for generating summarized training completions for
                                                Washington State Rating Bureau
                                            </CardText>
                                            <Link
                                                to="/wsrbsummary/form"
                                                className="btn btn-primary mx-auto"
                                            >
                                                View
                                            </Link>
                                        </CardBody>
                                    </Card>
                                </>
                            ) : null}
                        </Col>
                        {isWa ? (<Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">WSRB Detail Report</CardTitle>
                                    <CardText>
                                        Report for generating detailed training completions for
                                        Washington State Rating Bureau
                                    </CardText>
                                    <Link
                                        to="/wsrbdetail/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        ) : null}
                    </Row>
                    <Row>

                        

                    </Row>
                </CardBody>
            </Card>
        </Container>
    );
}
